<template>
  <div>
    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">基本信息</div>
    </div>
    <div v-if="detail">
      <van-cell title="报告创建时间" :value="createTime" :border="false" />
      <van-cell title="企业名称" :value="detail.enterprise.basic.name" :border="false" />
      <van-cell title="当前法人姓名" :value="detail.enterprise.basic.operName" :border="false" />
      <van-cell title="成立日期" :value="detail.enterprise.basic.startDate" :border="false" />
      <van-cell title="统一信用代码" :value="detail.enterprise.basic.creditNo" :border="false" />
      <van-cell title="行业分类" :value="detail.enterprise.basic.domains" :border="false" />
      <van-cell title="注册类型" :value="detail.enterprise.basic.econKind" :border="false" />
      <van-cell title="企业地址" :label="detail.enterprise.basic.address" :border="false" />
      <van-cell title="经营范围" :label="detail.enterprise.basic.scope" :border="false" />
      <van-cell title="股东明细" :border="false" />
      <div class="datatable">
        <div class="dataitem datahead">
          <div class="datacell">股东名称</div>
          <div class="datacell">参股数额</div>
          <div class="datacell">持股比例(%)</div>
        </div>
        <div class="dataitem" :key="index" v-for="(item, index) in detail.enterprise.partners">
          <div class="datacell">{{ item.name }}</div>
          <div class="datacell">{{ item.totalRealCapi }}</div>
          <div class="datacell">{{ item.stockRate }}</div>
        </div>
      </div>

      <van-cell title="银税互动授权记录" :border="false" />
      <div class="datatable">
        <div class="dataitem datahead">
          <div class="datacell">银行名称</div>
          <div class="datacell">申请时间</div>
          <div class="datacell">评价状态</div>
        </div>
        <div class="dataitem" :key="index" v-for="(item, index) in detail.yshdInfos">
          <div class="datacell">{{ item.dsfjgmc }}</div>
          <div class="datacell">{{ item.sqrq }}</div>
          <div class="datacell">{{ item.slzt }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: null,
    },
    createTime: {
      type: String,
    }
  }
}
</script>

<style></style>